import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8 mt-12">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center"
        >
          <div className="mb-4">
            <h3 className="text-2xl font-bold mb-2" style={{ color: '#FFFFFF' }}>
              OffCourt Official League
            </h3>
            <p className="text-gray-300 mb-4">
              Professional Padel League Management Platform
            </p>
          </div>
          
          <div className="border-t border-gray-700 pt-4">
            <p className="text-gray-400 mb-2">
              Powered by{' '}
              <a
                href="https://thinkincode.co.za"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-green-400 hover:text-green-300 transition-colors"
                style={{
                  fontSize: '1.125rem',
                  fontWeight: '600'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = '#FBBF24';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = '#FCD34D';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <span style={{ fontFamily: 'Poppins, sans-serif', fontWeight: '600' }}>thinkinCode(</span>
                <img 
                  src="/thinkincode-emblem.png" 
                  alt="ThinkinCode Emblem" 
                  style={{ 
                    width: '35px', 
                    height: '35px',
                    objectFit: 'contain',
                    verticalAlign: 'middle'
                  }} 
                />
                <span style={{ fontFamily: 'Poppins, sans-serif', fontWeight: '600' }}>);</span>
                <ExternalLink size={16} />
              </a>
            </p>
            <p className="text-sm text-gray-500">
              © {new Date().getFullYear()} OffCourt Official League. All rights reserved.
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;